import axios from 'axios'

import { callMBankBridge } from 'shared/lib/mbank-bridge'

import { getLocalStore } from './local-store'

const closeAppByApi = () => {
  axios.get('https://webview.mtravel.kg/api/v1/close-app/', {
    headers: {
      Authorization: `Bearer ${getLocalStore('mTravelToken')}`,
    },
  })
}

export const onCloseApp = () => {
  void callMBankBridge('app.close', {}).then((response) => {
    if (response.ok) return

    closeAppByApi()
  })
}
